import { render, staticRenderFns } from "./ProjectDashboard.vue?vue&type=template&id=6f319842&"
import script from "./ProjectDashboard.vue?vue&type=script&lang=js&"
export * from "./ProjectDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f319842')) {
      api.createRecord('6f319842', component.options)
    } else {
      api.reload('6f319842', component.options)
    }
    module.hot.accept("./ProjectDashboard.vue?vue&type=template&id=6f319842&", function () {
      api.rerender('6f319842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portfolio/projects/ProjectDashboard.vue"
export default component.exports